import { Ref, useEffect, useState } from "react";

import allImgPaths from "assets/images";
import CustomCheckBox from "components/CustomCheckBox";

function CustomizeInsight({ isShow, setIsShow, showGraph, setShowGraph }: any) {
  
  const handleChange = (name: any, isChecked: boolean) => {
    setShowGraph({ ...showGraph, [name]: isChecked })
  }

  return (
    <>
      <div className={`${isShow ? "block" : "hidden"} w-[688px] shadow-xl rounded-lg absolute top-full right-0 z-20 bg-white`}>
        <form>
          {/* Header */}
          <div className='pt-6 px-6 pb-5 border-b border-[#EAECF0]'>
            <div className='flex items-center justify-between'>
              <div className='flex justify-center items-center gap-x-4'>
                <img
                  className=''
                  src={allImgPaths.customizeInsighIcon}
                  alt='customize Insights'
                />

                <div>
                  <h2 className='text-lg text-[#101828] font-interSemiBold leading-none pb-1.5'>
                    Customize Insights Board
                  </h2>
                  <p className='text-sm text-[#475467]'>
                    Add/remove insights to customize the view as per your
                    preference
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Body */}
          <div className='px-7 pt-4 pb-3 border-b border-[#EAECF0]'>
            <div className='flex flex-wrap'>
              <div className='flex items-center gap-x-2 mb-4 w-1/2'>
                <span className='checkbox-alignment'>
                  <CustomCheckBox
                    name='feteCountDown'
                    label={""}
                    checked={showGraph.feteCountDown}
                    onChange={(name: string, isChecked: boolean) => handleChange(name, isChecked)}
                  />
                </span>
                <img src={allImgPaths.customizeInsighCountdown} alt='' />
                <p className='text-[#344054] font-interMedium'>
                  Fete Countdown
                </p>
              </div>

              <div className='flex items-center gap-x-2 mb-4 w-1/2'>
                <span className='checkbox-alignment'>
                  <CustomCheckBox
                    name='budgetUtilize'
                    label={""}
                    checked={showGraph.budgetUtilize}
                    onChange={(name: string, isChecked: boolean) => handleChange(name, isChecked)}
                  />
                </span>
                <img
                  src={allImgPaths.customizeInsighBudgetUtilization}
                  alt=''
                />
                <p className='text-[#344054] font-interMedium'>
                  Budget Utilization
                </p>
              </div>

              <div className='flex items-center gap-x-2 mb-4 w-1/2'>
                <span className='checkbox-alignment'>
                  <CustomCheckBox
                    name='budgetSplit'
                    label={""}
                    checked={showGraph.budgetSplit}
                    onChange={(name: string, isChecked: boolean) => handleChange(name, isChecked)}
                  />
                </span>
                <img src={allImgPaths.customizeInsighBudgetSplit} alt='' />
                <p className='text-[#344054] font-interMedium'>Budget Split</p>
              </div>

              <div className='flex items-center gap-x-2 mb-4 w-1/2'>
                <span className='checkbox-alignment'>
                  <CustomCheckBox
                    name='attendee_responses'
                    label={""}
                    checked={showGraph.attendee_responses}
                    onChange={(name: string, isChecked: boolean) => handleChange(name, isChecked)}
                  />
                </span>
                <img src={allImgPaths.customizeInsighBudgetSplit} alt='' />
                <p className='text-[#344054] font-interMedium'>
                  Attendee Responses
                </p>
              </div>

              <div className='flex items-center gap-x-2 mb-4 w-1/2'>
                <span className='checkbox-alignment'>
                  <CustomCheckBox
                    name='contract'
                    label={""}
                    checked={showGraph.contract}
                    onChange={(name: string, isChecked: boolean) => handleChange(name, isChecked)}
                  />
                </span>
                <img src={allImgPaths.customizeInsighInvoive} alt='' />
                <p className='text-[#344054] font-interMedium'>
                  Contract vs Invoice
                </p>
              </div>

              <div className='flex items-center gap-x-2 mb-4 w-1/2'>
                <span className='checkbox-alignment'>
                  <CustomCheckBox
                    name='attendee_location'
                    label={""}
                    checked={false}
                  />
                </span>
                <img src={allImgPaths.customizeInsighBudgetRollover} alt='' />
                <p className='text-[#344054] font-interMedium'>
                  Attendee Location
                </p>
              </div>

              <div className='flex items-center gap-x-2 mb-4 w-1/2'>
                <span className='checkbox-alignment'>
                  <CustomCheckBox
                    name='budgetRollOver'
                    label={""}
                    checked={showGraph.budgetRollOver}
                    onChange={(name: string, isChecked: boolean) => handleChange(name, isChecked)}
                  />
                </span>
                <img src={allImgPaths.customizeInsighBudgetRollover} alt='' />
                <p className='text-[#344054] font-interMedium'>
                  Budget Rollover
                </p>
              </div>

              <div className='flex items-center gap-x-2 mb-4 w-1/2'>
                <span className='checkbox-alignment'>
                  <CustomCheckBox
                    name='attendee_map'
                    label={""}
                    checked={false}
                  />
                </span>
                <img src={allImgPaths.customizeInsighAttendee} alt='' />
                <p className='text-[#344054] font-interMedium'>Attendee Map</p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className='pt-6 px-6 pb-6'>
            <div className='flex items-center gap-x-3 justify-center'>
              <button
                type='button'
                className={
                  `text-[#344054] font-interSemiBold border border-[#D0D5DD] hover:bg-[#f2f4f7] rounded-lg tracking-wide py-2.5 px-2.5 !text-base flex-1 `
                }
                onClick={() => setIsShow(false)}
              >
                Cancel
              </button>
              <button
                type='submit'
                className={
                  "text-[#fff] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-2.5 !text-base bg-[#1E0AF5] flex-1 hover:bg-[#120693]"
                }
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default CustomizeInsight;
